import script from "./Button.vue?vue&type=script&setup=true&lang=js"
export * from "./Button.vue?vue&type=script&setup=true&lang=js"

import "./Button.vue?vue&type=style&index=0&id=5d831da6&lang=postcss&scoped=true"
script.__scopeId = "data-v-5d831da6"

export default script